import { useCallback } from "react";
import { Chip } from "~/common/mui/Chip/Chip";
import { Stack, styled } from "~/common/mui";
import CloseIcon from "@mui/icons-material/Close";

import { useDispatch } from "react-redux";
import { clearAll } from "../../../../redux/actions";
import { Link } from "../../../../../../common/components/Link";

import { useTranslation } from "react-i18next";

import { useSearchPageType } from "~/features/search/context/SearchPageTypeContext";
import { type AppliedFilterData } from "~/features/search/components/Filters/components/AppliedFilters/useSelectAppliedFilters";

export const AppliedFilters = ({
  hideClearAll,
  appliedFilters,
}: {
  hideClearAll?: boolean;
  appliedFilters: AppliedFilterData[];
}) => {
  const { t } = useTranslation();

  const searchPageType = useSearchPageType();
  const dispatch = useDispatch();
  const onClearAll = useCallback(() => dispatch(clearAll(searchPageType)), [searchPageType]);

  if (!appliedFilters.length) {
    return null;
  }

  return (
    appliedFilters.length > 0 && (
      <Stack
        spacing={1}
        direction={"row"}
        sx={{
          flexWrap: "wrap",
          px: { phone: 0, tablet: 1.5 },
        }}
      >
        {appliedFilters.map(({ key, value, onClick }) => (
          <Chip key={key} variant="filter" selected label={value} deleteIcon={<CloseIcon />} onDelete={onClick} />
        ))}
        {!hideClearAll && <ClearLink onClick={onClearAll}>{t("searchPage.refinement.button.clearAll")}</ClearLink>}
      </Stack>
    )
  );
};

const ClearLink = styled(Link)(({ theme }) => ({
  whiteSpace: "nowrap",
}));
